import { Image, Platform } from 'react-native'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from './api-client'
import { log } from './utility'
import { logoUrl } from '@ecountabl/lib'
import { extra } from './config'

export type FeaturedTagsStatus = 'idle' | 'loading' | 'success' | 'error'

type FeaturedTagRecord = Record<string, any>

type FeaturedTagsState = {
  data: FeaturedTagRecord[]
  status: FeaturedTagsStatus
  error: string
}

const initialState: FeaturedTagsState = {
  data: [],
  status: 'idle',
  error: '',
}

export const fetchFeaturedTags = createAsyncThunk<any,void,{rejectValue: string}>('featuredTags', async (data, _api) => {
  try {
    const tags = await api.getFeaturedTags()
    if (Platform.OS !== 'web' || global.window) {
      tags.forEach(t => {
        const url = logoUrl(t.imgUrl, extra.cdn)
        if (!url) return

        Image.prefetch(url).then(res => {
          // console.log('prefetched featured tag image', t.imgUrl, res)
          // no-op
        }).catch(ex => {
          log.error(ex, {
            tags: {
              message: 'error preloading featured tag image',
              imgUrl: t.imgUrl
            }
          })
        })
      })
    }

    return tags
  } catch (err) {
    return _api.rejectWithValue(err.message || err.msg)
  }
})

const slice = createSlice({
  name: 'featuredTags',
  initialState,
  reducers: {
    clearFeaturedTags: (state): void => {
      state.data = []
      state.status = 'idle'
      state.error = ''
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFeaturedTags.pending, (state) => {
      state.status = 'loading'
      state.error = ''
    })
    .addCase(fetchFeaturedTags.fulfilled, (state, action) => {
      state.data = action.payload
      state.error = ''
      state.status = 'success'
    })
    .addCase(fetchFeaturedTags.rejected, (state, action) => {
      state.status = 'error'
      state.error = action.payload || 'Failed to fetch featured tags'
    })
  }
})

export const { clearFeaturedTags } = slice.actions

export default slice.reducer
